// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.hopscotch-bubble {
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 2px;
  z-index: 9999; }

div.hopscotch-bubble .hopscotch-bubble-container {
  padding-bottom: 0 !important;
  bottom: 0; }

div.hopscotch-bubble .hopscotch-bubble-content {
  margin: 0;
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  padding-bottom: 10px; }

div.hopscotch-bubble .hopscotch-bubble-content .hopscotch-title {
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  padding-bottom: 5px;
  font-weight: 400;
  font-size: 18px; }

div.hopscotch-bubble .hopscotch-bubble-content .hopscotch-content {
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif; }

div.hopscotch-bubble .hopscotch-circle-container {
  width: 100%;
  margin: 0 auto;
  display: inline-block;
  text-align: center; }

div.hopscotch-bubble .hopscotch-circle-container .hopscotch-circle {
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background: #fff;
  border: 1px solid #008ae2;
  margin: 0 3px;
  display: inline-block;
  cursor: pointer; }

div.hopscotch-bubble .hopscotch-circle-container .filled {
  background: #008ae2; }

div.hopscotch-bubble .hopscotch-actions {
  padding-bottom: 5px; }

div.hopscotch-bubble .hopscotch-actions .hopscotch-next-icon {
  fill: #fff;
  width: 10px;
  height: 10px;
  display: inline-block;
  padding-left: 2px; }

div.hopscotch-bubble .hopscotch-actions .hopscotch-tour-skip {
  color: #fff;
  float: left;
  padding-top: 4px;
  cursor: pointer; }

div.hopscotch-bubble .hopscotch-nav-button.next {
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 13px;
  border-color: transparent;
  margin: 0;
  text-shadow: none;
  background-color: transparent;
  background-image: none; }

div.hopscotch-bubble .hopscotch-nav-button:active {
  -webkit-box-shadow: 0 0 0 transparent inset;
  -moz-box-shadow: 0 0 0 transparent inset;
  box-shadow: 0 0 0 transparent inset;
  border-color: transparent; }

div.hopscotch-bubble .hopscotch-nav-button.next:hover {
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 13px;
  border-color: transparent;
  margin: 0;
  text-shadow: none;
  background-color: transparent;
  background-image: none;
  *zoom: 1;
  -webkit-box-shadow: 0 0 0 transparent;
  -moz-box-shadow: 0 0 0 transparent;
  box-shadow: 0 0 0 transparent; }

div.hopscotch-bubble .hopscotch-bubble-number {
  display: none;
  background: none; }

div.hopscotch-bubble .hopscotch-bubble-arrow-container {
  height: 20px;
  width: 20px; }

div.hopscotch-bubble .hopscotch-bubble-arrow-container.up {
  left: 0px !important; }

div.hopscotch-bubble .hopscotch-bubble-arrow-container.up {
  top: -16px; }

div.hopscotch-bubble
.hopscotch-bubble-arrow-container.up
.hopscotch-bubble-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 7.5px 15px 7.5px;
  border-color: transparent transparent #fff transparent;
  margin: 0 auto;
  position: relative; }

div.hopscotch-bubble
.hopscotch-bubble-arrow-container.up
.hopscotch-bubble-arrow-border {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 8px 16px 8px;
  margin: 0 auto;
  position: relative;
  margin-bottom: -4px; }

div.hopscotch-bubble .hopscotch-bubble-arrow-container.left {
  left: -16px; }

div.hopscotch-bubble
.hopscotch-bubble-arrow-container.left
.hopscotch-bubble-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 7.5px 15px 7.5px 0;
  border-color: transparent #fff transparent transparent;
  margin: auto 0;
  position: relative;
  left: 1.5px;
  top: -15.5px; }

div.hopscotch-bubble
.hopscotch-bubble-arrow-container.left
.hopscotch-bubble-arrow-border {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 16px 8px 0;
  margin: auto 0;
  position: relative;
  margin-right: -4px; }

div.hopscotch-bubble .hopscotch-bubble-arrow-container.down {
  bottom: -16px; }

div.hopscotch-bubble
.hopscotch-bubble-arrow-container.down
.hopscotch-bubble-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 15px 7.5px 0 7.5px;
  border-color: #008ae2 transparent transparent transparent;
  margin: 0 auto;
  position: relative;
  top: -17px; }

div.hopscotch-bubble
.hopscotch-bubble-arrow-container.down
.hopscotch-bubble-arrow-border {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 16px 8px 0 8px;
  margin: 0 auto;
  position: relative;
  margin-top: 4px; }

div.hopscotch-bubble .hopscotch-bubble-arrow-container.right {
  right: -16px; }

div.hopscotch-bubble
.hopscotch-bubble-arrow-container.right
.hopscotch-bubble-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 7.5px 0 7.5px 15px;
  border-color: transparent transparent transparent #fff;
  margin: auto 0;
  position: relative;
  left: 4px;
  top: -15px; }

div.hopscotch-bubble
.hopscotch-bubble-arrow-container.right
.hopscotch-bubble-arrow-border {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 0 8px 16px;
  margin: auto 0;
  position: relative;
  margin-left: 4px; }

div.hopscotch-bubble .hopscotch-bubble-close svg {
  display: block; }

div.hopscotch-bubble:before {
  content: '';
  position: absolute;
  background: #008ae2;
  bottom: 0;
  left: 0;
  right: 0;
  height: 36px; }

.hopscotch-overlay {
  position: fixed;
  background-color: black;
  opacity: 0.4;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9998;
  overflow: hidden; }
`, "",{"version":3,"sources":["webpack://./src/components/onboardingMessages/hopscotch.override.css"],"names":[],"mappings":"AAAA;EACE,wEAAwE;EACxE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa,EAAE;;AAEjB;EACE,4BAA4B;EAC5B,SAAS,EAAE;;AAEb;EACE,SAAS;EACT,wEAAwE;EACxE,oBAAoB,EAAE;;AAExB;EACE,wEAAwE;EACxE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe,EAAE;;AAEnB;EACE,wEAAwE,EAAE;;AAE5E;EACE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,eAAe,EAAE;;AAEnB;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB,EAAE;;AAErB;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,eAAe,EAAE;;AAEnB;EACE,wEAAwE;EACxE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB,EAAE;;AAE1B;EACE,2CAA2C;EAC3C,wCAAwC;EACxC,mCAAmC;EACnC,yBAAyB,EAAE;;AAE7B;EACE,wEAAwE;EACxE,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;GACtB,OAAQ;EACR,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B,EAAE;;AAEjC;EACE,aAAa;EACb,gBAAgB,EAAE;;AAEpB;EACE,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,oBAAoB,EAAE;;AAExB;EACE,UAAU,EAAE;;AAEd;;;EAGE,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,sDAAsD;EACtD,cAAc;EACd,kBAAkB,EAAE;;AAEtB;;;EAGE,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,mBAAmB,EAAE;;AAEvB;EACE,WAAW,EAAE;;AAEf;;;EAGE,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,sDAAsD;EACtD,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAE;;AAEhB;;;EAGE,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,kBAAkB,EAAE;;AAEtB;EACE,aAAa,EAAE;;AAEjB;;;EAGE,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,yDAAyD;EACzD,cAAc;EACd,kBAAkB;EAClB,UAAU,EAAE;;AAEd;;;EAGE,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,eAAe,EAAE;;AAEnB;EACE,YAAY,EAAE;;AAEhB;;;EAGE,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,sDAAsD;EACtD,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU,EAAE;;AAEd;;;EAGE,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,cAAc,EAAE;;AAElB;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,aAAa;EACb,gBAAgB,EAAE","sourcesContent":["div.hopscotch-bubble {\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  border-radius: 2px;\n  z-index: 9999; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-container {\n  padding-bottom: 0 !important;\n  bottom: 0; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-content {\n  margin: 0;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  padding-bottom: 10px; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-content .hopscotch-title {\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  padding-bottom: 5px;\n  font-weight: 400;\n  font-size: 18px; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-content .hopscotch-content {\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif; }\n\ndiv.hopscotch-bubble .hopscotch-circle-container {\n  width: 100%;\n  margin: 0 auto;\n  display: inline-block;\n  text-align: center; }\n\ndiv.hopscotch-bubble .hopscotch-circle-container .hopscotch-circle {\n  border-radius: 50%;\n  height: 10px;\n  width: 10px;\n  background: #fff;\n  border: 1px solid #008ae2;\n  margin: 0 3px;\n  display: inline-block;\n  cursor: pointer; }\n\ndiv.hopscotch-bubble .hopscotch-circle-container .filled {\n  background: #008ae2; }\n\ndiv.hopscotch-bubble .hopscotch-actions {\n  padding-bottom: 5px; }\n\ndiv.hopscotch-bubble .hopscotch-actions .hopscotch-next-icon {\n  fill: #fff;\n  width: 10px;\n  height: 10px;\n  display: inline-block;\n  padding-left: 2px; }\n\ndiv.hopscotch-bubble .hopscotch-actions .hopscotch-tour-skip {\n  color: #fff;\n  float: left;\n  padding-top: 4px;\n  cursor: pointer; }\n\ndiv.hopscotch-bubble .hopscotch-nav-button.next {\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  border-color: transparent;\n  margin: 0;\n  text-shadow: none;\n  background-color: transparent;\n  background-image: none; }\n\ndiv.hopscotch-bubble .hopscotch-nav-button:active {\n  -webkit-box-shadow: 0 0 0 transparent inset;\n  -moz-box-shadow: 0 0 0 transparent inset;\n  box-shadow: 0 0 0 transparent inset;\n  border-color: transparent; }\n\ndiv.hopscotch-bubble .hopscotch-nav-button.next:hover {\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  border-color: transparent;\n  margin: 0;\n  text-shadow: none;\n  background-color: transparent;\n  background-image: none;\n  *zoom: 1;\n  -webkit-box-shadow: 0 0 0 transparent;\n  -moz-box-shadow: 0 0 0 transparent;\n  box-shadow: 0 0 0 transparent; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-number {\n  display: none;\n  background: none; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container {\n  height: 20px;\n  width: 20px; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.up {\n  left: 0px !important; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.up {\n  top: -16px; }\n\ndiv.hopscotch-bubble\n.hopscotch-bubble-arrow-container.up\n.hopscotch-bubble-arrow {\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 7.5px 15px 7.5px;\n  border-color: transparent transparent #fff transparent;\n  margin: 0 auto;\n  position: relative; }\n\ndiv.hopscotch-bubble\n.hopscotch-bubble-arrow-container.up\n.hopscotch-bubble-arrow-border {\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 8px 16px 8px;\n  margin: 0 auto;\n  position: relative;\n  margin-bottom: -4px; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.left {\n  left: -16px; }\n\ndiv.hopscotch-bubble\n.hopscotch-bubble-arrow-container.left\n.hopscotch-bubble-arrow {\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 7.5px 15px 7.5px 0;\n  border-color: transparent #fff transparent transparent;\n  margin: auto 0;\n  position: relative;\n  left: 1.5px;\n  top: -15.5px; }\n\ndiv.hopscotch-bubble\n.hopscotch-bubble-arrow-container.left\n.hopscotch-bubble-arrow-border {\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 8px 16px 8px 0;\n  margin: auto 0;\n  position: relative;\n  margin-right: -4px; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.down {\n  bottom: -16px; }\n\ndiv.hopscotch-bubble\n.hopscotch-bubble-arrow-container.down\n.hopscotch-bubble-arrow {\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 15px 7.5px 0 7.5px;\n  border-color: #008ae2 transparent transparent transparent;\n  margin: 0 auto;\n  position: relative;\n  top: -17px; }\n\ndiv.hopscotch-bubble\n.hopscotch-bubble-arrow-container.down\n.hopscotch-bubble-arrow-border {\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 16px 8px 0 8px;\n  margin: 0 auto;\n  position: relative;\n  margin-top: 4px; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.right {\n  right: -16px; }\n\ndiv.hopscotch-bubble\n.hopscotch-bubble-arrow-container.right\n.hopscotch-bubble-arrow {\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 7.5px 0 7.5px 15px;\n  border-color: transparent transparent transparent #fff;\n  margin: auto 0;\n  position: relative;\n  left: 4px;\n  top: -15px; }\n\ndiv.hopscotch-bubble\n.hopscotch-bubble-arrow-container.right\n.hopscotch-bubble-arrow-border {\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 8px 0 8px 16px;\n  margin: auto 0;\n  position: relative;\n  margin-left: 4px; }\n\ndiv.hopscotch-bubble .hopscotch-bubble-close svg {\n  display: block; }\n\ndiv.hopscotch-bubble:before {\n  content: '';\n  position: absolute;\n  background: #008ae2;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 36px; }\n\n.hopscotch-overlay {\n  position: fixed;\n  background-color: black;\n  opacity: 0.4;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 9998;\n  overflow: hidden; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
